import { render } from "./startLocation.vue?vue&type=template&id=d02da9e4"
import script from "./startLocation.vue?vue&type=script&lang=js"
export * from "./startLocation.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__